import axios from "axios";
import { HOST_API_KEY } from "../../config";

export const EVENT_TYPES = {
    newFans: 'newFans',
    homePageVisitors: 'homePageVisitors',
    views: 'views',
    interactions: 'interactions'
}

const getAuthToken = () => {
    if (typeof window === "undefined") return null;

    const token = localStorage.getItem("jwtToken");
    if (!token || token === "null" || token === "undefined") return null;

    return token;
};

export const sendAnalyticsEvent = async (eventType, userId) => {
    const token = getAuthToken();

    if (!token || !eventType || !userId) {
        return null;
    }

    try {
        return await axios.post(`${HOST_API_KEY}/user-analytics`, {
            eventType,
            userId
        }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        })
    } catch (error) {
        return null;
    }
}
